import Wrapper from '@app/Wrapper.js'

Munio.UserProfile = class extends Wrapper {
  constructor(selector, user, departments, hasDepartmentsEnabled) {
    super(selector, { user, departments, hasDepartmentsEnabled })
  }

  component() {
    return import('./App.vue')
  }
}
